export default {
    name : 'youtube',

    init()
    {
        setTimeout(this.run, 500);
    },
    run ()
    {
        const elements = document.querySelectorAll('.video__container.youtube');
        for (let i in elements) {
            if (typeof elements[i].dataset !== "undefined" && typeof elements[i].dataset.embed === "string") {
                let iframe = '<iframe width="100%" height="100%" src="'+elements[i].dataset.embed+'" title="youtube video" class="border-radius" frameborder="0" allow="autoplay;accelerometer;clipboard-write; encrypted-media; gyroscope; picture-in-picture"> </iframe>';
                elements[i].innerHTML = iframe;
            }
        }
    }
}